<!--
  详情页
  props:
    id: 详情 id
    moduleName: 模块名
  emit:
    refresh: 提交刷新列表请求
    closeDetail: 关闭详情页
 -->

<template>
  <div class="detail" :class="{'mini-width': miniWidth}">
    <div class="head">
      <h1 class="title">
        <div class="title-wrap">
          <div class="chapter" v-if="isBad && status === 6">
            <img src="../../assets/imgs/bad.png"/>
          </div>
          <div class="chapter" v-else-if="isBad && status === 7">
            <img src="../../assets/imgs/badpart.png"/>
          </div>
          <div class="chapter" v-else-if="isCancel">
            <img src="../../assets/imgs/cancel.png"/>
          </div>
          <span class="text" :class="{red: isRed}">{{header.title}}</span>
          <template v-if="['customerApi', 'opportunityApi'].indexOf(moduleName) > -1">
            <i class="el-star" @click="handleFocus" :class="[isFocus ? 'el-icon-star-on' : 'el-icon-star-off']"></i>
          </template>
          <div class="tag-list" v-if="header.tags">
            <el-tooltip :content="tag.memo" placement="bottom" effect="light" v-for="(tag, index) in header.tags" :key="index">
              <span class="tag" :class="'tagbg-'+tag.tagType">
                {{tag.tagName}}
              </span>
            </el-tooltip>
          </div>
        </div>
      </h1>

      <!-- 拨号按钮 -->
      <div class="cti-btn" v-if="phoneList.length">
        <i class="web-icon-dial" @click="makeCall"></i>
      </div>
      <!-- 设置BOM版本 -->
      <template v-if="['bomBill'].indexOf(moduleName) > -1 && header.isShow">
        <el-checkbox v-model="header.isDefault" @change="changeBomVersion">设为默认版本</el-checkbox>
      </template>
      <div class="button-items">
        <!-- 右上角操作按钮，配置信息参考/config/common-config.js menuType -->
        <el-button-group v-if="permission && permission.length">
          <el-button
            v-for="btn in permission"
            :key="btn"
            :icon="'el-icon-' + menuType[btn].icon"
            :class="menuType[btn].icon"
            @click="handleBtn(btn)">
            {{menuType[btn].name}}
          </el-button>
        </el-button-group>
        <a href="#" class="question"><i class="web-icon-information"></i></a>
      </div>
    </div>
    <div class="desc" v-if="header.secondTitle">
      <span class="text" v-for="(value, key) in header.secondTitle" :key="value+key">{{key}}：{{value}}</span>
    </div>

    <customer-stage-flow
      v-if="moduleName === 'customerApi' && customerStage.allStageArray && customerStage.allStageArray.length"
      :customerStage="customerStage"
      :customerId="id"
      :customerType="customerType"
      @openLoseBecause="loseBecauseShow = true"
      @createContract="createContract"
      @refresh="refreshCustomerStage"
    ></customer-stage-flow>

    <!-- 销售阶段副标题 -->
    <div class="oppo-desc" v-if="opportunity">
      <div class="item">
        <a class="title" @click="handleTransfer('customerApi', opportunity.baseTitle.customerId)" href="javascript:;">{{opportunity.baseTitle.customerName}}</a>
      </div>
      <div class="item">
        <span class="name">预计金额：</span>
        <span class="text">{{opportunity.baseTitle.estimateAmount}}</span>
      </div>
      <div class="item">
        <span class="name">停留时长：</span>
        <span class="text">{{opportunity.baseTitle.lastedtime}}</span>
      </div>
      <div class="item">
        <span class="name">预计结束日期：</span>
        <span class="text">{{opportunity.baseTitle.estimateEndTime}}</span>
      </div>
    </div>
    <!-- 销售阶段 -->
    <div class="oppo-stage" v-if="opportunity">
      <ul class="stage-list" :class="{disable: opportunity.nowType > 1}">
        <template v-for="(item, index) in opportunity.allStageArray">
          <li class="option" v-if="item.type === 2" v-show="!opportunity.nowType" >
            <a href="javascript:;" class="link" @click="jumpConfirm(item,true)">输单</a>
          </li>
          <li class="option" v-else-if="item.type === 3" v-show="!opportunity.nowType">
            <a href="javascript:;" class="link cancel" @click="jumpConfirm(item)">取消</a>
          </li>
          <li
            v-else
            class="item"
            @click="changeStage(item)"
            :class="{'progress': item.sort >= opportunity.nowSort && opportunity.nowType <= 1 && opportunity.nowSort !== null}">
            <span class="name">{{item.stageName}}</span>
            <!-- 销售阶段提醒浮窗 -->
            <ul class="mini-modal" v-if="item.sort >= opportunity.nowSort">
              <li class="p break-all">
                <span class="label">第 {{index + 1}} 阶段：</span>
                <span class="text">{{item.stageName}}（赢率{{item.estimateWinRate}}%）</span>
              </li>
              <li class="p">
                <span class="label">阶段用时：</span>
                <span class="text">{{item.usedDay}}</span>
              </li>
              <li class="p">
                <span class="label">经历阶段：</span>
                <span class="text">{{item.intoTime}}~{{item.outTime}}</span>
              </li>
            </ul>
          </li>
        </template>
        <li class="lastedtime" v-show="opportunity.nowType">总历时：{{opportunity.baseTitle.lastedtime}}</li>
      </ul>
    </div>

    <div class="content">
      <div class="con-left" v-if="['productApi'].indexOf(moduleName) === -1">
        <!-- 业务流转按钮 -->
        <div class="entry" v-if="workFlow.length">
        <!-- item.id：-2为审批中 -->
          <el-button v-for="item in workFlow" :disabled="item.id === -2" :key="item.title" @click="handleTransfer(item.key, item.id)">{{item.title}}</el-button>
        </div>
        <!-- 销售团队 -->
        <sale-team
          :id="id"
          :moduleName="moduleName"
          @refresh="getList"
          v-if="['customerApi', 'opportunityApi', 'contractApi', 'workOrder', 'supplier', 'purchase', 'bomBill', 'productionOrder'].indexOf(moduleName) > -1 && !isPublic && routeChild !== 'isDel'">
        </sale-team>

        <basic-item
          :detailData="detailData"
          :otherDetail="otherDetail"
          :rates="rates"
          :origin="origin"
          :moduleName="moduleName"
          @openDetail="handleTransfer">
          <span slot="title">供应商评分</span>
        </basic-item>
      </div>
      <div class="con-right" :class="moduleName"
       :style="['productApi'].indexOf(moduleName) > -1 ? 'width:100%':'width:665px'">
        <template v-if="tabCon && tabCon.length">
          <div class="tab-two">
            <el-tabs :value="currentView" @tab-click="tabClick">
              <template v-for="tab in tabCon">
                <el-tab-pane  :label="tab.title" :name="tab.module" :key="tab.module"></el-tab-pane>
              </template>
            </el-tabs>
          </div>

          <div class="tab-con" v-if="childrenShow" ref="conRight">
            <keep-alive include="fileCabinet">
              <component
                :is="currentView"
                :id="id"
                :ref="currentView"
                :loading="scrollData"
                :moduleName="moduleName"
                :refresh="reCommunicate"
                :superBtn="superBtn"
                @refresh="refreshCustomerStage"
                @openSupplierAddNew="supplierAddNew"
                @openDetail="handleTransfer"
                @createContract="createContract">
              </component>
            </keep-alive>
          </div>

          <!-- 新增工单动态 -->
          <div class="dynamic-warp" v-if="currentView === 'workorderDynamic'">
            <add-dynamic :id="id" @update="refreshDynamic"></add-dynamic>
          </div>
        </template>
        <div class="no-detail" v-else>无可用模块，请到<a @click="goToAppStore('/application/list')">模板管理</a>中启用！</div>
      </div>
    </div>
    <span class="detailClose" @click="closeDetail"><i class="el-icon-close"></i></span>

    <!-- 详情 -->
    <transition name="slide">
      <detail
        ref="detail"
        v-if="detailShow"
        :moduleName="detailName"
        :id="detailId"
        @close="closeChild"
        @refresh="getDetail()">
      </detail>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="detailShow" @click="detailShow=false"></div>
    </transition>

    <!-- 新建 -->
    <add-new
      ref="addNew"
      :modal="false"
      v-if="addnewShow"
      @closeForDetail="addnewShow=false"
      @refresh="getList"
      @callback="adnewCB"
      @communicatePlan="addPlan"
      @closeConfirm="closeConfirm"
      @changeOppStage="jumpStage"
      :addnewProp="addnewProp">
    </add-new>

    <!-- 跟进提醒 -->
    <remind
      v-if="remindShow"
      :modal="false"
      :customer="remindProps"
      :moduleName="moduleName"
      @refresh="getList"
      @closeDialog="remindShow=false">
    </remind>

    <!-- 拨号界面 -->
    <dial-modal
      v-if="dialModalShow"
      :dialStyle="dialStyle"
      :phoneList="phoneList"
      @closeModal="dialModalShow=false">
    </dial-modal>

    <div class="v-modal" v-show="remindShow"></div>

    <!-- 设置完成访客计划 -->
    <customer-plan
      v-if="planShow"
      :listData="planData"
      :selectVisitPlan="selectVisitPlan"
      :isItem="true"
      @close="planShow=false"
      @visitPlanSave="visitPlanSave">
    </customer-plan>

    <!-- 打印选择对话框 -->
    <Print v-if="choosePrintType"
    :entityIdProp="id"
    :moduleName="moduleName"
    :templateIdProp="templateMsg.templateId"
    :refType="templateMsg.refType"
    @closeDialog="closePrint"
    >
    </Print>
    <!-- 销售机会输单原因填写 -->
    <transition name="slide">
      <lose-cause
        v-if="loseCauseShow"
        :loseCauseShow="loseCauseShow"
        :oppId="opportunityId"
        :code="currentCode"
        :nextCode="nextOppCode"
        :flag="flag"
        @refresh="getList"
        @close="loseCauseShow = false"
        >
      </lose-cause>
    </transition>

    <!-- 客户流失原因 -->
    <lose-because
      v-if="loseBecauseShow"
      :customerId="id"
      :templateId="templateId"
      @refresh="refreshCustomerStage"
      @close="loseBecauseShow = false"
    ></lose-because>
  </div>
</template>

<script>
import { Message, MessageBox } from 'element-ui'
import { mapGetters, mapActions } from 'vuex'
import * as api from 'src/api'
import * as common from 'src/config/common-config'
import { LS } from 'assets/js/storage' // 本地存储要用到
// import * as mixin from 'src/config/mixin'
import Print from '../modal/print' // 打印模块
import basicItem from 'components/detail/basic-item'
import saleTeam from 'components/detail/sale-team'
import detail from './detail'
import addNew from 'components/modal/add-new'
import Remind from 'components/modal/customer/remind'
import dialModal from 'components/common/dial-modal'
import customerPlan from 'components/modal/opportunity/customer-plan'
import loseCause from 'components/modal/opportunity/lose-cause'
import addDynamic from 'components/modal/work-order/add-dynamic' // 工单评价
import loseBecause from 'components/modal/customer/lose-because'

import purchaseProduct from 'components/detail/purchase/product-list'
import purchasePayplan from 'components/detail/purchase/pay-plan-list'
import instockLog from 'components/detail/purchase/instock-log'

import instockProduct from 'components/detail/instock/product-list'
import supplierPurchase from 'components/detail/supplier/purchase-record'
import supplierPayment from 'components/detail/supplier/payment-record'
import supplierContacts from 'components/detail/supplier/contacts'
import supplierProduct from 'components/detail/supplier/product-list'
import returnedProduct from 'components/detail/returned-purchase/product-list'
import outstockProduct from 'components/detail/outstock/product-list'
import inventoryProduct from 'components/detail/inventory/product-list'
import transferProduct from 'components/detail/transfer/product-list'

import productTab from 'components/detail/product/product-tab'
import stockTab from 'components/detail/product/stock-tab'
import contractTab from 'components/detail/product/contract-tab'
import supplierTab from 'components/detail/product/supplier-tab'
import personTab from 'components/detail/product/person-tab'
import instockTab from 'components/detail/product/instock-tab'
import outstockTab from 'components/detail/product/outstock-tab'
import batchTab from 'components/detail/product/batch-tab'
import guaranteeTab from 'components/detail/product/guarantee-tab'
import purchaseTab from 'components/detail/product/purchase-tab'

import customerContact from 'components/detail/customer/contact'
import customerContract from 'components/detail/customer/customer-contract'
import saleOpportunity from 'components/detail/customer/sale-opportunity'
import parentAndChild from 'components/detail/customer/parent-and-child'
import customerStage from 'components/detail/customer/customer-stage'
import customerStageFlow from 'components/detail/customer-stage-flow'

import opportunityProduct from 'components/detail/opportunity/product-list'
import contractProduct from 'components/detail/contract/product-list'
import Performance from 'components/detail/contract/performance'
import contractPayment from 'components/detail/contract/payment-list'
import outstockLog from 'components/detail/contract/outstock-log'
import refundProduct from 'components/detail/red-contract/product-list'
import redPayment from 'components/detail/red-contract/payment-list'
import canceledInvoice from 'components/detail/red-contract/canceled-invoice'
import redPerformance from 'components/detail/red-contract/red-performance'

import outAssemble from 'components/detail/assemble/outproduct-list'
import inAssemble from 'components/detail/assemble/inproduct-list'

import bomProduct from 'components/detail/bom-bill/product-list' // BOM详情产品
import proOrderProduct from 'components/detail/production-order/product-list' // 生产单详情产品
import structure from 'components/detail/bom-bill/structure' // 结构图

import workorderDynamic from 'components/detail/work-order/dynamic' // 工单动态
import workorderProgress from 'components/detail/work-order/divprogress' // 工单进度
import workorderProducts from 'components/detail/work-order/product-list' // 工单备件
import workorderEvaluate from 'components/detail/work-order/evaluate' // 工单评价

import fileCabinet from 'components/detail/file-cabinet'
import returnedRecord from 'components/detail/returned-record'
import communicateRecord from 'components/detail/communicate-record-new'
import invoiceDetail from 'components/detail/invoice-detail'
import invoiceHistory from 'components/detail/invoice-history'
import WorkOrderLog from 'components/detail/work-order-log'
import callLog from 'components/detail/call-log'

import invoiceBasicItem from 'components/detail/invoice/invoice-basic-item'
import customerExpress from 'components/detail/invoice/customer-express'
import customerInvoice from 'components/detail/invoice/customer-invoice'

import cashReceipt from 'components/detail/payment/cash-receipt'
// import { throws } from 'assert'
let repeatNum = 0 // bindScroll被重复调用的次数

import draggable from 'vuedraggable'

export default {
  // mixins: [mixin.list],
  created () {
    this.getDetail()
    // 标为红冲的合同有单独的tabs
    if (this.getRedStatus && this.moduleName === 'contractApi') {
      this.tabCon = this.getDetailConfig.redContractApi
    } else if (this.getRedStatus && this.moduleName === 'paymentApi') {
      this.tabCon = this.getDetailConfig.redPaymentApi
    } else {
      this.tabCon = this.getDetailConfig[this.moduleName]
    }
  },

  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String,
      required: true
    },
    // 客户模块的额外字段
    routeChild: {
      type: String
    },
    // 是否是审批入口
    isApproval: {
      type: Boolean,
      default: false
    }
  },
  name: 'detail',
  data () {
    return {
      choosePrintType: false,
      detailData: [],
      otherDetail: null,
      origin: {}, //  红冲回款编号的原回款信息
      rates: [],
      header: {},
      // 业务流转
      workFlow: [],
      productArray: [], // 待采购产品
      supplierIdList: [], // 待采购产品供应商
      currentIndex: 0, // 当前被选中的tab 序号
      detailShow: false,
      detailId: 5,
      detailName: '',
      // 权限配置信息
      permission: [],
      // 模块对应名称
      moduleMap: common.moduleMap,
      // 按钮对应的文字和样式
      menuType: common.menuType,
      // 销售机会阶段和副标题
      opportunity: null,
      // 新建
      addnewShow: false,
      addnewProp: {
        // id: id
      },
      // 跟进提醒
      remindShow: false,
      remindProps: {},
      // 关注切换
      isFocus: 0,
      childrenShow: false, // 是否显示子组件
      scrollData: 1, // 监听滚动状态
      reCommunicate: false, // 控制跟进记录是否刷新
      // 发票详情
      express: {},
      invoice: {},
      superBtn: false, // 是否在跟进记录中显示高级选项
      tabCon: [], // 当前模块要显示的详情tabs
      dialStyle: {}, // 拨号列表显示位置
      dialModalShow: false,
      phoneList: [], // 拨号列表
      versionIsDefault: false, // BOM默认版本
      // 访客计划
      planData: [],
      planShow: false,
      selectVisitPlan: {},
      relativeRedInvoices: [],
      isBad: false, //  坏账的戳的标记
      isCancel: false, //  作废的戳的标记
      status: 0, //  标记坏账和部分坏账
      crossMonth: false, //  该条发票是否是跨月的标记
      hasRed: 0, //  该条发票是否包含红冲
      isRed: false, //  标记是否是红冲发票
      templateMsg: {}, //  跳到打印模板需要带过去的参数
      loseCauseShow: false, // 输单原因的弹框
      opportunityId: 0, // 销售机会id
      currentCode: 0, // 当前销售机会code
      nextOppCode: 0, // 下一个销售机会code
      customerStage: {}, // 客户阶段
      loseBecauseShow: false, // 客户流失原因
      isPublic: '', // 是否是公海客户
      customerType: 'customer',
      tabSortShow: false,
      dialogVisible: false,
      isAppendToBody: true,
      isDropShow: false,
      flag: false, // 区分跳转输单阶段的标志
      templateId: '',
      isParent: true // 是否有上下级
    }
  },
  computed: {
    ...mapGetters(['getDetailConfig', 'getRedStatus', 'getCTIStatus']),
    miniWidth () {
      if (this.moduleName === 'invoice') {
        return true
      } else {
        return false
      }
    },
    // 当前选中的模块名
    currentView () {
      if (this.tabCon && this.tabCon.length) {
        return this.tabCon[this.currentIndex].module
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions([
      'setStage',
      'updateSelectrows',
      'toggleCtiModal',
      'initPayment',
      'setPaymentType',
      'toggleCtiModal',
      'setContactType'
    ]),
    // 打电话
    makeCall (event) {
      // 判断是否开启CTI
      if (this.getCTIStatus) {
        if (this.phoneList.length <= 1) {
          window.CALL_CENTER.callme(this.phoneList[0].phoneNum)
        } else {
          // 显示电话列表弹层
          const position = event.target.getBoundingClientRect()
          this.dialStyle = {
            left: `${position.left + 30}px`,
            top: `${position.top - 6}px`
          }
          setTimeout(() => {
            this.dialModalShow = true
          }, 50)
        }
      } else {
        Message({
          type: 'warning',
          message: '第一次使用呼叫中心，请在右下角弹窗完成认证！'
        })
        this.toggleCtiModal(true)
      }
    },

    // 监听Tab栏点击事件
    tabClick (obj, e) {
      this.currentIndex = Number(obj.index)
      // if (this.moduleName === 'customerApi' || this.moduleName === 'contractApi') {
      //   let childColl = document.querySelector('.tab-drop').children
      //   for (let i = 0; i < childColl.length; i++) {
      //     childColl[i].style.display = 'block'
      //   }
      //   document.getElementById('tab-more').style.color = '#303133'
      //   document.getElementById('tab-more').innerHTML =
      //     '更多(' +
      //     (this.tabCon.length - 5) +
      //     ")<i class='el-icon-arrow-down'></i>"
      // }
    },

    // tab栏展开项的点击事件
    tabSelect (e) {
      this.isDropShow = false
      document.getElementById('tab-more').classList.add('is-active')
      let childColl = this.$refs.drop.children
      for (let i = 0; i < childColl.length; i++) {
        childColl[i].style.display = 'block'
      }
      this.currentIndex = e.target.getAttribute('index') || undefined
      document.getElementById('tab-more').innerHTML =
        e.target.innerHTML + " <i class='el-icon-arrow-down'></i>"
      e.target.style.display = 'none'
    },

    // tab栏展开与隐藏
    dropShow () {
      this.isDropShow = true
      document.getElementById('tab-more').style.color = '#409EFF'
    },

    // 保存排序结果
    saveSort () {
      this.dialogVisible = false
      let resColl = this.$refs.sortlist && this.$refs.sortlist.$el.children
      this.tabCon = []
      this.$nextTick(() => {
        for (let i = 0; i < resColl.length; i++) {
          this.tabCon.push({title: resColl[i].innerText, module: resColl[i] ? resColl[i].getAttribute('module') : undefined})
        }
      })
      this.currentIndex = 0
    },

    // 绑定滚动下拉加载更多方法
    bindScroll () {
      const el = this.$refs.conRight
      let oldSt = 0
      let timer
      repeatNum++

      // 如果等待时间超过1S，则终止执行，避免出现死循环
      if (repeatNum > 20) return

      if (el) {
        el.onscroll = ('scroll',
        e => {
          let st = el.scrollTop
          let oh = el.offsetHeight
          let sh = el.scrollHeight

          // 增加300毫秒延时，防止短时间内被触发多次
          clearTimeout(timer)

          // 滚动到底部20px内且向下滚动时触发
          timer = setTimeout(() => {
            if (st + oh > sh - 20 && st > oldSt) {
              this.scrollData++
            }
            oldSt = st
          }, 300)
        })
      } else {
        setTimeout(this.bindScroll, 50)
      }
    },

    // 获取详情数据
    getDetail () {
      let url = `/${this.moduleName}/detailAjax.html`
      let params = {
        id: this.id,
        isApproval: this.isApproval ? 1 : undefined
      }
      if (this.moduleName === 'contactApi') {
        params.refType = this.refType
      }
      api.post(url, params, (data) => {
        this.permission = data.detailPermissionSet
        this.header = data.header
        this.isFocus = data.isFocus
        this.isParent = data.isParent
        this.isRed = data.isRed
        this.hasRed = data.hasRed
        this.templateId = data.templateId
        if (this.moduleName === 'customerApi') {
          this.customerType = data.child
          this.isPublic = data.child === 'isPublic'
        }

        this.origin = data.origin
        if (data.isBad) {
          this.isBad = data.isBad
        }
        if (data.isCancel) {
          this.isCancel = data.isCancel
        }

        if (data.status) {
          this.status = data.status
        }

        if (data.crossMonth) {
          this.crossMonth = data.crossMonth
        }

        // 供应商有评分
        if (this.moduleName === 'supplier') {
          this.rates.length = 0
          this.detailData.length = 0
          data.result.forEach((item) => {
            if (item.fieldType === 10) {
              this.rates.push(item)
            } else {
              this.detailData.push(item)
            }
          })
        } else {
          this.detailData = data.result
        }

        //  拿到跳到打印模板需要的参数
        if (data.templateMsg) {
          this.templateMsg = data.templateMsg
        }

        // 其他信息
        this.otherDetail = data.otherDetail || null

        // 业务流转
        this.workFlow = this.returnWorkFlow(data.workFlow)
        // 销售机会阶段和副标题
        this.opportunity = data.opportunityTitle || null

        // 发票管理
        this.express = data.customerExpressDetail
        this.invoice = data.customerInvoiceDetail
        this.relativeRedInvoices = data.relativeRedInvoices

        // 跟进记录是否显示高级按钮
        if (data.superBtn) this.superBtn = true

        // 拨打电话
        if (data.header.dial) {
          if (typeof data.header.dial === 'string') {
            data.header.dial = JSON.parse(data.header.dial)
          }
          this.phoneList = data.header.dial
        }

        // 获取采购信息
        if (this.moduleName === 'contractApi' && data.waitPurchaseMap) {
          this.productArray = data.waitPurchaseMap.productArray
          this.supplierArray = data.waitPurchaseMap.supplierArray
        }

        this.childrenShow = true

        if (!this.miniWidth) {
          // 重置计数器
          repeatNum = 0
          this.bindScroll()
        }

        if (data.customerStage) {
          this.customerStage = data.customerStage
        }

        if (this.moduleName === 'customerApi' && !this.isParent) {
          this.tabCon = this.tabCon.filter(tab => {
            return tab.module === 'parentAndChild' ? false : tab
          })
        }
      },
        () => {
          this.$emit('close')
        }
      )
    },
    // 操作
    handleBtn (btn) {
      if (btn === 'edit') {
        this.handleEdit()
      } else if (btn === 'del') {
        this.handleDelete()
      } else if (btn === 'print') {
        this.openPrintDialog()
      } else if (btn === 'recall') {
        this.handleRecall()
      } else if (btn === 'copy') {
        this.handleCopy()
      } else if (btn === 'archiveBatch') {
        this.archivedRows(1)
      } else if (btn === 'cancelArchive') {
        this.archivedRows(0)
      } else if (btn === 'cancel') {
        this.cancelHandel(1)
      } else if (btn === 'revertCancel') {
        this.cancelHandel(0)
      } else if (btn === 'red') {
        //  详情页的红冲操作
        this.addRed()
      } else if (btn === 'badDebt') {
        this.badOrReturnDebt('badDebt')
      } else if (btn === 'return') {
        this.badOrReturnDebt('return')
      } else if (btn === 'termination') {
        // 生产单终止
        this.terminationOrder()
      } else if (btn === 'finish') {
        // 生产单完成
        this.operatingOrder('finish')
      } else if (btn === 'restart') {
        // 生产单重启
        this.operatingOrder('restart')
      } else if (btn === 'close') {
        // 生产单关闭
        this.operatingOrder('close')
      } else {
        console.warn(btn)
      }
    },
    // 关闭详情页
    closeDetail () {
      this.$emit('close')
    },
    closePrint () {
      this.choosePrintType = false
    },
    // 删除确认
    handleDelete () {
      let sureMsg = ''
      if (this.hasRed) {
        sureMsg = `将同步删除红冲发票,`
      }
      const msg =
        this.moduleName === `customerApi`
          ? `删除客户同时会删除销售机会、联系人、跟进记录等客户相关信息，存在合同的客户不允许删除！`
          : `${sureMsg}确定删除该数据吗?`
      MessageBox.confirm(msg, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteItem()
        })
        .catch(() => {})
    },
    // 删除
    deleteItem () {
      let url = `/${this.moduleName}/delete.html`
      let params = {
        id: [this.id]
      }
      api.post(url, params, data => {
        // 有些情况下，客户不允许被删除
        const ECL = data.errorCustomerList
        const ETL = data.errorTypeList
        if (ECL && ECL.length) {
          MessageBox.alert('', {
            title: `删除提醒`,
            message: `该客户因“${ETL.join(',')}”，不允许被删除！`,
            confirmButtonText: '知道了'
          })
        } else {
          Message({
            type: 'success',
            message: '删除成功!'
          })
          this.closeDetail()
          this.$emit('refresh')
          // 同步到vuex
          this.updateSelectrows({ del: this.id })
        }
      })
    },
    // 打开新建窗口
    openAddnew () {
      if (
        [
          'purchase',
          'instock',
          'outstock',
          'returnedPurchase',
          'assemble',
          'transfer',
          'inventory',
          'waitPurchaseApi',
          'productApi',
          'bomBill',
          'productionOrder'
        ].indexOf(this.moduleName) === -1
      ) {
        if (
          (this.addnewProp && this.addnewProp.module === 'contractApi') ||
          ((!this.addnewProp || (this.addnewProp && !this.addnewProp.module)) &&
            this.moduleName === 'contractApi')
        ) {
          let str = this.addnewProp && this.addnewProp.id ? 'edit' : 'item'
          this.setPaymentType('contractApi-' + str)
          this.initPayment()
        }
        if (!this.addnewShow) {
          this.addnewShow = true
        } else {
          // 获取子组件的props
          const childAnp = this.$refs.addNew.addnewProp // 已经传给子组件的props
          const parentAnp = this.addnewProp // 即将传给子组件的props

          /*
            * childAnp 条件成立时，说明新建窗口被打开过，并且没有被销毁
            * childAnp.id，有id值，说明上一次是编辑操作
            * childAnp.module 有module，说明上一次操作是另一个模块的新建动作
            * parentAnp 存在id属性说明当前操作时编辑，不是新建
            * parentAnp 存在module属性说明当前要打开另一个模块的新建
          */
          if (
            (childAnp && childAnp.id) ||
            (childAnp && childAnp.module) ||
            parentAnp.id ||
            parentAnp.module
          ) {
            this.addnewShow = false
            this.$nextTick(() => {
              this.openAddnew()
            })
          } else {
            if (this.moduleName === 'customerApi') {
              let str = 'customerApi-item'
              this.setContactType(str)
            }
            this.$refs.addNew.dialogFormVisible = true
          }
        }
        // 供应商新建编辑联系人后刷新详情页列表
        if (this.moduleName === 'supplier') {
          this.getList()
        }
      } else {
        this.openJxcAddNew()
      }
    },

    // 打开新版新建页
    openJxcAddNew () {
      let params = {}
      let query = {
        moduleName: this.addnewProp.module,
        refId: this.addnewProp.refId,
        type: this.addnewProp.type,
        id: this.addnewProp.id,
        formCopyId: this.addnewProp.formCopyId,
        flowType: flowType
      }
      let flowType = ''
      if (
        this.addnewProp &&
        this.addnewProp.module === 'purchase' &&
        this.addnewProp.type === 'contractApi'
      ) {
        // 同时存到本地，防止刷新页面后数据丢失
        LS.set('VUE-supplierIdList', this.supplierIdList)
        LS.set('VUE-productArray', this.productArray)
        params = {
          supplierIdList: this.supplierArray,
          productArray: this.productArray
        }
        query.flowType = 'contractWaitPurchase'
      }
      this.$router.push({
        name: 'jxcAddPage',
        query: query,
        params: params
      })
    },

    // 编辑
    handleEdit () {
      this.addnewProp = {
        id: this.id,
        module: this.moduleName
      }
      this.openAddnew()
    },

    //  坏账和还原
    badOrReturnDebt (btn) {
      //  坏账操作
      if (btn === 'badDebt') {
        this.addnewProp = {
          modelType: 'bad',
          refId: this.id,
          formTitle: '回款坏账',
          idBad: 1
        }
        if (this.moduleName === 'paymentApi') {
          this.addnewProp.module = 'paymentSheetApi'
        }
        this.openAddnew()
      } else {
        //  还原操作
        let params = {
          id: this.id,
          isBad: 0
        }
        MessageBox.confirm('确定还原该数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let url = `/paymentApi/badDebtReturn.html`
          api.post(url, params, data => {
            this.getList()
          })
        })
      }
    },

    //  详情页的发票红冲和回款的红冲
    addRed () {
      if (this.moduleName === 'invoice') {
        this.addnewProp = {
          originId: this.id,
          module: 'invoice',
          formTitle: '红冲发票开票'
        }
      } else if (this.moduleName === 'paymentApi') {
        this.addnewProp = {
          module: 'paymentSheetApi',
          modelType: 'red',
          refId: this.id,
          formTitle: '新建红冲回款单',
          isRed: 1
        }
      }
      this.openAddnew()
    },

    // 复制
    handleCopy () {
      this.addnewProp = {
        formCopyId: this.id,
        module: this.moduleName
      }
      this.openAddnew()
    },
    print (data) {
      this.choosePrintType = data
    },
    openPrintDialog () {
      // 打开打印选择模板
      this.choosePrintType = true
    },
    // 终止生产单
    terminationOrder () {
      let url = `/productionOrder/termination.html`
      let params = {
        id: this.id
      }
      api.post(url, params, data => {
        Message({
          type: 'success',
          message: data.msg || '设置成功!'
        })
        this.getDetail()
        this.$emit('refresh')
      })
    },
    // 生产单完成关闭重启按钮
    operatingOrder (type) {
      let url = `/productionOrder/setStatus.html`
      let arr = []
      if (this.id) {
        arr.push(this.id)
      }
      let params = {
        id: arr,
        type: type
      }
      api.post(url, params, data => {
        // 审批中
        if (data.isApproval) {
          Message({
            type: 'success',
            message: data.msg
          })
          this.closeDetail()
          this.$emit('refresh')
          return false
        }
        Message({
          type: 'success',
          message: data.msg
        })
        this.getDetail()
        this.$emit('refresh')
      })
    },
    // 打印
    // handlePrint () { 暂时用，用新方法替代，先不用删
    //   //  前置判断
    //   let url = '/printTemplate/templateExist.do'
    //   let entityId = parseInt(this.id)
    //   let templateId = parseInt(this.templateMsg.templateId)
    // let params = {
    //   refType: refType,
    //   templateId: templateId,
    //   entityId: entityId
    // }

    // // 在Safari中，无法在回调函数中使用window.open
    // let winRef = window.open('', '_blank')
    // api.post(url, params, (data) => {
    //   //  跳到新的打印模板
    //   if (data.ifnewtemplate === 1) {
    //     let entityIdCode = data.entityIdCode
    //     let corpidCode = data.corpidCode
    //     if (api.path) {
    //       url = 'http://localhost:8086/#/printTemplate?enable=' + 1 + '&entityId=' + entityId + '&refType=' + this.templateMsg.refType + '&templateId=' + this.templateMsg.templateId + '&entityIdCode=' + entityIdCode + '&corpidCode=' + corpidCode
    //     } else {
    //       url = 'print/index.htm#/printTemplate?enable=' + 1 + '&entityId=' + entityId + '&refType=' + this.templateMsg.refType + '&templateId=' + this.templateMsg.templateId + '&entityIdCode=' + entityIdCode + '&corpidCode=' + corpidCode
    //     }
    //     this.$nextTick(() => {
    //       winRef.location = url
    //     })
    //   } else {
    //     //  继续执行老的打印方法
    //     const corpid = this.$cookies.get('corpid') || ''
    //     this.$nextTick(() => {
    //       winRef.location = `/${this.moduleName}/print.html?${this.moduleName}Id=${this.id}&corpid=${corpid}`
    //     })
    //   }
    // })
    // },
    // 供应商联系人新建编辑
    supplierAddNew (obj) {
      this.addnewProp = obj
      this.openAddnew()
    },
    // 业务流转
    handleTransfer (type, id, isEdit, nextId) {
      /*
        type 为模块名
        id 解释
          0 业务流转 生成
          others 业务流转 查看
          'new' 客户管理 新建
          'remind' 客户管理 跟进提醒
        nextId 下一个阶段（不传为空）
      */
      if (id === 'remind') {
        this.remindProps = {
          id: this.id,
          title: this.header.title,
          managerId: this.header.userIds
        }
        this.addRemind()
      } else if (id === 'new' || id === 0) {
        let prop = {
          refId: this.id,
          module: type,
          type: this.moduleName
        }
        // 生产单特殊，同时会有两种入库类型按钮
        if (type === 'finshedProduct') {
          prop.module = 'instock'
          prop.type = 'finshedProduct'
        } else if (type === 'returnedMateriel') {
          prop.module = 'instock'
          prop.type = 'returnedMateriel'
        } else if (type === 'materiel') {
          prop.module = 'outstock'
          prop.type = 'materiel'
        }
        this.newWorkFlow(prop)
      } else if (type === 'stageFeedbackApi') {
        // 销售机会--销售阶段
        const prop = {
          id: isEdit ? this.id : '',
          opportunityId: this.id,
          module: type,
          stageCode: id,
          nextStageCode: nextId
        }
        this.newWorkFlow(prop)
      } else {
        this.detailId = id
        this.detailShow = true
        this.detailName = type
      }
    },
    // 生成 workFlow的数据
    returnWorkFlow (obj) {
      const maps = {
        remind: '跟进提醒',
        opportunityApi: '销售机会',
        contractApi: '合同订单',
        instockId: '入库单',
        outstockId: '出库单',
        purchase: '采购合同',
        returnedPurchaseId: '采购退货',
        communicateApi: '跟进记录',
        invoice: '发票',
        contactApi: '联系人',
        supplierContact: '联系人', // 供应商联系人
        paymentSheetApi: '回款单',
        refund: '退货退款',
        finshedProduct: '成品入库', // 生产单成品入库
        materiel: '物料出库', // 生产单物料出库
        returnedMateriel: '退料入库', // 生产单退料入库
        workOrder: '工单'
      }
      let arr = []
      for (let key in obj) {
        let title = ''
        let after = ''
        if (obj[key] === 0) {
          title = '生成'
        } else if (obj[key] === 'new') {
          title = '新建'
        } else if (obj[key] === 'remind') {
          title = '设置'
        } else if (obj[key] === -2) {
          after = '审批中'
        } else {
          title = '查看'
        }
        arr.push({
          title: `${title}${maps[key]}${after}`,
          key: key.replace('Id', ''),
          id: obj[key]
        })
      }

      function sortObj (a, b) {
        const sort = {
          remind: 1,
          opportunityApi: 2,
          contractApi: 3,
          instock: 4,
          outstock: 5,
          returnedPurchase: 6,
          communicateApi: 7,
          invoice: 8,
          contactApi: 9,
          paymentSheetApi: 10,
          refund: 11
        }
        return sort[a.key] - sort[b.key]
      }
      arr.sort(sortObj)
      return arr
    },
    // 业务流转生成表单
    newWorkFlow (obj) {
      if (obj.module === 'invoice') {
        this.addnewProp = {}
        this.addnewProp.refIds = [obj.refId]
        this.addnewProp.module = obj.module
        this.addnewProp.type = obj.type
      } else if (
        ['outstock', 'returnedPurchase', 'instock', 'purchase'].indexOf(
          obj.module
        ) > -1
      ) {
        this.addnewProp = obj
        this.openJxcAddNew()
        return
      } else {
        this.addnewProp = obj
      }
      this.openAddnew()
    },
    // 刷新列表页
    getList () {
      this.getDetail()
      this.$emit('refresh')
      this.reCommunicate = !this.reCommunicate
      if (
        this.currentView === 'saleStage' ||
        this.currentView === 'supplierContacts'
      ) {
        this.$refs[this.currentView].getList() // 刷新销售阶段详情页的数据
      }
    },
    // 归档 & 取消归档
    archivedRows (archived) {
      // 判断当前是归档还是取消归档
      let cancel = archived === 1 ? '' : '取消'
      const h = this.$createElement
      const warning =
        this.moduleName === 'customerApi' && archived === 1
          ? '归档客户为短时间内不需要跟进的客户，归档后不影响业务使用。'
          : ''

      MessageBox.confirm(
        `确认${cancel}归档 “${this.header.title}” 吗?`,
        `${cancel}归档确认`,
        {
          title: `${cancel}归档确认`,
          message: h('div', { class: 'confirm-con' }, [
            h('h4', { class: 'tit' }, warning),
            h(
              'div',
              { class: 'msg' },
              `确认${cancel}归档 “${this.header.title}” 吗?`
            )
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          const url = `/${this.moduleName}/archived.html`
          const params = {
            ids: [this.id],
            archived: archived
          }
          api.post(url, params, data => {
            Message({
              type: 'success',
              message: data.msg || '操作成功!'
            })
            this.getDetail()
            this.$emit('refresh')
          })
        })
        .catch(() => {})
    },
    // 作废确认
    cancelHandel (type) {
      let status = type ? '作废' : '还原'

      let sureMsg = ''
      if (this.crossMonth) {
        sureMsg = '该发票已经跨月,'
      }

      MessageBox.confirm(`${sureMsg}是否${status} “${this.header.title}” 吗?`, `${status}确认`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cancelInvoice(type)
      }).catch(() => {})
    },
    // 作废&还原
    cancelInvoice (type) {
      let url = '/invoice/cancel.html'
      let params = {
        id: [this.id],
        isCancel: type
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.getDetail()
        this.$emit('refresh')
      })
    },
    // 撤销
    handleRecall () {
      MessageBox.confirm(`${this.moduleMap[this.moduleName]}正在审批中，是否要进行撤回?`, '撤回确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `/approval/recall.html`
        let params = {
          refId: this.id,
          refType: this.moduleName
        }
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: '撤回成功!'
          })
          this.getDetail()
          this.$emit('refresh')
        })
        .catch(() => {})
      })
    },
    // 设置跟进提醒
    addRemind () {
      this.remindShow = true
    },
    // 关闭下一级详情
    closeChild () {
      this.detailShow = false
    },
    // 关注切换
    handleFocus () {
      let url, params
      // 转换0和1
      let status = Math.abs(this.isFocus - 1)
      this.isFocus = status

      if (this.moduleName === 'customerApi') {
        url = '/customerApi/customerFocus.html'
        params = {
          customerId: this.id,
          isFocus: status
        }
      } else if (this.moduleName === 'opportunityApi') {
        url = '/opportunityApi/opportunityFocus.html'
        params = {
          opportunityId: this.id,
          isFocus: status
        }
      }
      api.post(url, params, (data) => {
        if (document.getElementById('focus' + this.id)) {
          // 操作ＤＯＭ
          if (status) {
            document.getElementById('focus' + this.id).className = 'ico el-icon-star-on'
            document.getElementById('focus' + this.id).dataset.status = status
          } else {
            document.getElementById('focus' + this.id).className = 'ico el-icon-star-off'
            document.getElementById('focus' + this.id).dataset.status = status
          }
        }
      })
    },
    // 准备改变销售阶段
    changeStage (obj) {
      let current = this.opportunity
      // 向前跳转阶段时，不需要填写阶段反馈
      if (!current.nowUseForm) {
        this.jumpConfirm(obj)
      } else {
        this.nextOppCode = obj.stageCode
        this.handleTransfer('stageFeedbackApi', current.nowStageCode, false, obj.stageCode)
      }
    },
    jumpConfirm (obj, flag) {
      if (flag) {
        this.opportunityId = this.id
        this.loseCauseShow = true
        this.currentCode = obj.stageCode
        this.flag = flag
      } else {
        MessageBox.confirm(`确认跳转到${obj.stageName}阶段吗？`, '销售机会阶段变更', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.jumpStage(obj.stageCode)
        }).catch(() => {})
      }
    },
    // 跳转销售阶段
    jumpStage (code) {
      this.flag = false
      let url = `/opportunityApi/changeStageSave.html`
      let params = {
        id: this.id,
        code: code || this.nextOppCode
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '跳转成功!'
        })

        // 判断是否开启审批
        if (data.isApproval) {
          this.$emit('close')
          return
        }

        this.getList()
        // 改变vuex中的stage状态
        this.setStage(code)

        // 是否为赢单状态
        if (data.isWin) {
          this.createdContract(data.opportunityId, data.salesStageName)
        }

        // 是否为输单状态
        if (data.salesStageType === 2) {
          this.closeConfirm(data.opportunityId)
        }
      })
    },
    // 更改销售机会为赢单时，提示是否要生成合同
    createdContract (id, name) {
      MessageBox.confirm(`该机会已经“${name}”，是否生成合同`, '生成合同确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.addnewProp = {
          refId: id,
          module: 'contractApi',
          type: 'opportunityApi'
        }
        this.openAddnew()
      }).catch(() => {})
    },
    // 成交客户生成合同
    createContract (params) {
      this.addnewProp = params
      this.openAddnew()
    },
    // 接收从addNew返回的回调
    adnewCB (module, argu) {
      if (module === 'opportunityApi' && argu) {
        this.createdContract(argu.id, argu.name)
      } else {
        this.$emit('close', module)
      }
    },
    // 设置完成访客计划
    addPlan (data, selectVisitPlan) {
      this.selectVisitPlan = selectVisitPlan
      this.planData = data
      setTimeout(() => {
        this.planShow = true
      }, 100)
    },
    visitPlanSave (plan) {
      this.$refs.addNew.form.synchronizeCommunicatePlan = plan
    },

    // 刷新工单列表
    refreshDynamic () {
      this.$refs.workorderDynamic.getDynamic()
    },

    // 输单原因
    closeConfirm (id) {
      this.opportunityId = id
      this.flag = false
      setTimeout(() => {
        this.loseCauseShow = true
      }, 100)
    },

    // 跳转到模块设置
    goToAppStore (path) {
      // menu-211为模块设置的id，通过查询页面中是否存在该ID，来判断用户是否有权限访问模块设置
      const appStore = document.getElementById('menu-211')

      if (appStore) {
        this.$router.push(path)
      } else {
        Message({
          type: 'warning',
          message: '没有访问模块设置的权限，请联系管理员开启！'
        })
      }
    },

    // 设置BOM版本默认版本
    changeBomVersion (val) {
      let url = `bomBill/setDefaultVersion.html`
      let params = {
        refid: this.id,
        isDefault: this.header.isDefault
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '设置成功!'
        })
      })
    },
    // 在客户详情时变更客户状态，如果当前页是阶段工作，把阶段工作也刷新
    refreshCustomerStage () {
      if (this.currentView === 'customerStage') {
        this.$refs.customerStage.initDate()
      }
      this.getList()
    }
  },
  components: {
    Print,
    customerPlan,
    basicItem,
    saleTeam,
    detail,
    addNew,
    Remind,
    dialModal,
    purchaseProduct,
    purchasePayplan,
    instockProduct,
    supplierPurchase,
    supplierPayment,
    supplierContacts,
    supplierProduct,
    returnedProduct,
    outstockProduct,
    inventoryProduct,
    transferProduct,
    customerContact,
    customerContract,
    saleOpportunity,
    returnedRecord,
    parentAndChild,
    communicateRecord,
    fileCabinet,
    opportunityProduct,
    saleStage: (resolve) => {
      require.ensure(['components/detail/opportunity/sale-stage'], () => resolve(require('components/detail/opportunity/sale-stage')), 'sale-stage')
    },
    contractProduct,
    Performance,
    contractPayment,
    outAssemble,
    inAssemble,
    invoiceDetail,
    invoiceHistory,
    instockLog,
    outstockLog,
    cashReceipt,
    // proDetail,
    refundProduct,
    bomProduct,
    proOrderProduct,
    structure,
    redPayment,
    canceledInvoice,
    redPerformance,
    callLog,
    WorkOrderLog,
    workorderDynamic,
    workorderProgress,
    workorderEvaluate,
    workorderProducts,
    addDynamic,
    customerExpress,
    customerInvoice,
    customerStage,
    invoiceBasicItem,
    productTab,
    stockTab,
    contractTab,
    supplierTab,
    personTab,
    instockTab,
    outstockTab,
    batchTab,
    guaranteeTab,
    purchaseTab,
    loseCause,
    customerStageFlow,
    loseBecause,
    draggable
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/detail.less";
.invoice {
  width: 645px !important;
}
.detail {
  &.mini-width {
    width: 650px;
  }
  &.mini-width .content .con-right {
    width: 645px;
  }
  .con-right {
    display: flex!important;
    flex-direction: column;
    /deep/.el-tabs__header {
      z-index: 0;
    }
    .tab-con {
      font-size: 14px;
    }
  }
  .oppo-desc {
    display: flex;
    padding: 15px 0;
    .item {
      flex: 1 1 auto;
      padding: 0 30px;
      line-height: 20px;
      text-align: center;
      border-right: 1px solid #dedede;
      font-family: "microsoft Yahei";
      &:last-child {
        border-right-width: 0;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        color: @primary;
      }
      .name {
        font-size: 13px;
        color: @light-gray;
      }
      .text {
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
  .oppo-stage {
    border: 5px solid #dce1e8;
    border-bottom: 0;
    padding: 10px 15px 10px 40px;
    .stage-list {
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        font-size: 13px;
        line-height: 32px;
        padding-left: 40px;
        padding-right: 20px;
        background-color: #f5f5f5;
        margin: 5px 16px 5px 0;
        cursor: pointer;
        transition: opacity 0.2s;
        &:hover {
          .mini-modal {
            display: block;
          }
        }
        &:after,
        &:before {
          content: "";
          position: absolute;
          border-width: 16px;
          border-style: solid;
          top: 0;
        }
        &:before {
          border-color: transparent transparent transparent #ffffff;
          left: 0px;
        }
        &:after {
          border-color: transparent transparent transparent #f5f5f5;
          right: -31px;
        }
        &.progress {
          background-color: @bg-orange;
          color: #fff;
          &:after {
            border-left-color: @bg-orange;
          }
        }
        &:first-child {
          padding-left: 20px;
          &:before {
            border-color: #f5f5f5;
            border-radius: 16px;
            overflow: hidden;
            left: -16px;
          }
          &.progress {
            &:before {
              border-color: @bg-orange;
            }
          }
        }
        .mini-modal {
          position: absolute;
          box-sizing: border-box;
          width: 250px;
          min-height: 100px;
          border-radius: 2px;
          background-color: #fff;
          box-shadow: 0 0 6px 0 rgba(105, 105, 105, 0.5);
          padding: 8px 12px 6px;
          font-size: 13px;
          left: 0;
          margin-left: -50%;
          top: 45px;
          z-index: 200;
          display: none;
          &:before {
            position: absolute;
            left: 50%;
            margin-left: -16px;
            top: -8px;
            content: "";
            width: 16px;
            height: 16px;
            transform: rotate(45deg);
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(105, 105, 105, 0.5);
            z-index: -1;
          }
          &:after {
            position: absolute;
            left: 50%;
            margin-left: -21px;
            top: 0px;
            content: "";
            width: 26px;
            height: 12px;
            background-color: #fff;
          }
          .p {
            height: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.break-all {
              white-space: normal;
              height: auto;
            }
            .label {
              color: @light-gray;
              margin-right: 2px;
            }
            .text {
              font-size: 13px;
              color: #666;
            }
          }
        }
      }
      .lastedtime {
        margin-top: 5px;
        margin-left: 12px;
        line-height: 30px;
        font-size: 15px;
      }
      .option {
        line-height: 32px;
        margin-left: 20px;
        margin-top: 5px;
        .link {
          margin: 0 5px;
          font-size: 14px;
          &.cancel {
            color: #666;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
      &.disable {
        .item {
          color: @light-gray;
        }
      }
    }
  }
}
.confirm-con {
  .tit {
    font-size: 14px;
    line-height: 1.5;
    color: @bg-orange;
  }
  .msg {
    margin-top: 12px;
  }
}
.detail {
  .head {
    display: flex;
    height: 80px;
    box-sizing: border-box;
    vertical-align: middle;
    .title {
      position: relative;
      left: 0;
      flex: 1;
      height: 80px;
      .title-wrap {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        // display: flex;
        span {
          flex: 1;
          line-height: 24px;
        }
        i {
          margin-top: 2px;
        }
        .cti-btn {
          flex: 0 0 auto;
        }
      }
      .button-items {
        flex: 0 0 auto;
        align-items: flex-end;
      }
    }
    /deep/.el-checkbox {
      line-height: 31px;
      padding-right: 15px;
    }
  }
}
.add-new {
  position: relative;
  z-index: 50;
}
.chapter {
  display: inline-block;
  width: 64px;
  height: 64px;
  position: absolute;
  left: 300px;
  top: -24px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// detail.vue?f388693e